import React, { Component } from 'react';
import classNames from 'classnames';

export default class Resizer extends Component {
  constructor(props = { onReset, onAdd, onSubtract, currentSize, maxSize }){
    super(props);
    this.state = {
      initialStep: 50,
      step: 50 / (this.props.maxSize || 1)
    }
  }
  componentDidMount(){
    this.$chip.style.left = `${ this.calcStep }%`;
  }
  componentDidUpdate(){
    this.$chip.style.left = `${ this.calcStep }%`;
  }
  render(){
    let { step, initialStep } = this.state;
    let { onReset, onAdd, onSubtract, currentSize } = this.props;
    this.calcStep = initialStep + (step * currentSize);
    let rangeClass = classNames('billy-resizer__range', {
      'billy_active': currentSize
    })
    return (
      <div className="billy-resizer">
        <div className={ rangeClass }>
          <div className="billy-resizer__range__space">
            <div className="billy-resizer__range__value" 
                 ref={(el) => { this.$chip = el; }}>
                 { currentSize }
            </div>
          </div>
        </div>
        <div className="billy-resizer__actions">
          <button className="billy-resizer__button billy-button fi-billy fi-billy-refresh" 
                  aria-label="אפס" 
                  onClick={ onReset }>
          </button>  
          <button className="billy-resizer__button billy-button fi-billy fi-billy-plus" 
                  aria-label="הגדל"
                  onClick={ onAdd }>
          </button>
          <button className="billy-resizer__button billy-button fi-billy fi-billy-minus" 
                  aria-label="הקטן" 
                  onClick={ onSubtract }>
          </button>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Resizer/index.js